module.exports = __webpack_public_path__ + "static/bind-app.c5843189.png";